<template>
    <div>
        <div class="box">
            <nav class="level">
                <div class="level-left">
                    <b-button @click="$router.push(`${$route.path}/new`)" class="level-item" type="is-primary">
                        <b-icon icon="plus-circle" pack="fas" />
                        <span>New {{ itemName }}</span>
                    </b-button>
                    <!-- <form @submit.prevent="search">
                        <b-field>
                            <b-input placeholder="Search..." type="search" v-model="searchQuery"></b-input>
                            <p class="control">
                                <b-button class="button is-primary" native-type="submit">Search</b-button>
                            </p>
                        </b-field>
                    </form> -->
                </div>
                <div class="level-right">
                    <b-switch v-model="stickyHead" :true-value="false" :false-value="true" left-label
                        >Full Page</b-switch
                    >
                    <b-input class="level-item" disabled :value="'Total: ' + total.toLocaleString('en-US')" />
                </div>
            </nav>
            <b-table
                narrowed
                bordered
                striped
                :sticky-header="stickyHead"
                :height="stickyHead ? '720px' : undefined"
                :current-page="page"
                :data="items"
                :default-sort="[sortField, sortOrder]"
                default-sort-direction="desc"
                :loading="isLoading"
                :per-page="perPage"
                :total="total"
                @page-change="onPageChange"
                @sort="onSort"
                backend-pagination
                backend-sorting
                hoverable
                paginated
                icon-pack="fas"
            >
                <b-table-column
                    v-for="(col, index) in columns"
                    :key="index"
                    :field="col.field"
                    :label="col.label"
                    :sortable="col.sortable"
                    v-slot="props"
                >
                    <template v-if="col.formatDate">
                        {{ props.row[col.field] | formatDate }}
                    </template>
                    <template v-else-if="col.formatNumber">
                        {{ props.row[col.field] | formatNumber }}
                    </template>
                    <template v-else-if="col.mapToIcon">
                        <b-tooltip
                            :type="item.type"
                            :label="`${item.label ? item.label : props.row[col.field]}`"
                            v-for="(item, index) in col.mapToIcon"
                            :key="index"
                        >
                            <b-icon
                                v-if="item.value === props.row[col.field]"
                                :key="index"
                                :icon="item.icon"
                                :type="item.type"
                            />
                            <template v-else>
                                <template v-if="item.else">
                                    {{ props.row[col.field] }}
                                </template>
                            </template>
                        </b-tooltip>
                    </template>
                    <template v-else-if="col.innerField">
                        {{ props.row[col.field][col.innerField] }}
                    </template>
                    <template v-else>
                        {{ props.row[col.field] }}
                    </template>
                </b-table-column>

                <b-table-column label="Actions" width="135" v-slot="props">
                    <b-tooltip label="Edit">
                        <a @click="$router.push(`${$route.path}/${props.row.id}`)">
                            <b-icon icon="file-document-edit-outline"></b-icon>
                        </a>
                    </b-tooltip>
                    <b-tooltip label="Delete" type="is-danger">
                        <a @click="deleteItem(props.row.id, 'delete')">
                            <b-icon icon="delete" type="is-danger"></b-icon>
                        </a>
                    </b-tooltip>
                </b-table-column>

                <template slot="empty">
                    <section class="section">
                        <div class="content has-text-grey has-text-centered">
                            <p>
                                <b-icon icon="frown" pack="far" size="is-large"></b-icon>
                            </p>
                            <p>Nothing here.</p>
                        </div>
                    </section>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            itemName: "Contributor",
            apiURI: "/contributors",
            items: [],
            columns: [
                {
                    field: "id",
                    label: "ID",
                    width: "40",
                    numeric: true,
                    sortable: true,
                },
                {
                    field: "name",
                    label: "Name",
                },
                {
                    field: "position",
                    label: "Position",
                },
                {
                    field: "created_at",
                    label: "Created Date",
                    centered: true,
                    sortable: true,
                    formatDate: true,
                },
            ],
            total: 0,
            perPage: 1,
            page: 1,
            sortField: "created_at",
            sortOrder: "desc",
            searchQuery: "",
            searchStr: "",
            isLoading: true,
            stickyHead: false,
        };
    },
    methods: {
        async init() {
            this.loadTable();
        },
        onPageChange(page) {
            this.page = page;
            this.loadTable();
        },
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.loadTable();
        },
        async loadTable() {
            this.isLoading = true;
            let params = [
                `page=${this.page}`,
                `sort=${this.sortField}`,
                `order=${this.sortOrder}`,
                this.searchQuery ? `search=${this.searchQuery}` : "",
            ].join("&");
            try {
                let res = await this.$http.get(this.apiURI + "?" + params);
                this.items = res.data.data;
                this.total = res.data.total;
                this.page = res.data.current_page;
                this.perPage = res.data.per_page;
            } catch (error) {
                this.items = [];
                this.total = 0;
                this.page = 1;
            }
            this.isLoading = false;
        },
        search() {
            if (this.searchQuery == "") {
                this.searchStr = "";
            } else {
                this.searchStr = "&" + `search=${this.searchQuery}`;
            }
            this.page = 1;
            this.loadTable();
        },
        deleteItem(id, action) {
            this.$buefy.dialog.confirm({
                title: action,
                message: `Are you sure you want to <b>${action}</b> this member?`,
                confirmText: action,
                type: "is-danger",
                hasIcon: true,
                onConfirm: () => {
                    this.isLoading = true;
                    // Send request to server
                    this.$http
                        .delete(`${this.apiURI}/${id}`)
                        .then(() => {
                            this.notify(`Contributor member ${action}!`, "is-success");
                            this.loadTable();
                        })
                        .catch(() => {
                            this.notify(`There were something wrong`, "is-danger");
                            this.isLoading = false;
                        });
                },
            });
        },
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {},
};
</script>

